import React, { useRef } from 'react';
import { Link } from '../../../Link';
import * as Styles from './styles';
export const SkipLinks = ({ headerWrapperRef, mainId, footerId }) => {
    const wrapperRef = useRef(null);
    const goToFirstElement = (event) => {
        var _a;
        if (event.key === 'Enter') {
            event.preventDefault();
            const menuElement = (_a = headerWrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.burger-menu');
            const isMobile = window.innerWidth < 840;
            if (isMobile)
                return menuElement === null || menuElement === void 0 ? void 0 : menuElement.focus();
            const nextElement = menuElement === null || menuElement === void 0 ? void 0 : menuElement.nextElementSibling;
            nextElement === null || nextElement === void 0 ? void 0 : nextElement.focus();
        }
    };
    return (React.createElement(Styles.SkipWrapper, { ref: wrapperRef },
        React.createElement(Link, { dsParentName: "Header", href: "#header", onKeyDown: goToFirstElement, "data-header-keyboard-navigation": "true", className: "skip-link" }, "Ir para o menu principal"),
        React.createElement(Link, { dsParentName: "Header", href: mainId, className: "skip-link", "data-header-keyboard-navigation": "true" }, "Ir para o conte\u00FAdo da p\u00E1gina"),
        React.createElement(Link, { dsParentName: "Header", href: footerId, className: "skip-link", "data-header-keyboard-navigation": "true" }, "Ir para o rodap\u00E9")));
};
SkipLinks.displayName = 'SkipLinks';
